import axios from "axios";
import { getServerApiUrl } from "shared";
import i18n from "../features/content/i18n";
import handleAuthError from "./authErrorHandler";

// Variabele om de header bij te houden
let dossierHeader = null;

// Create the base axios instance with common configuration
const serverApiUrl = getServerApiUrl();
const axiosClient = axios.create({
  baseURL: serverApiUrl,
  withCredentials: true,
});

// Functie om de dossier header in te stellen
export const setDossierHeader = (dossier) => {
  dossierHeader = dossier; // Gewoon updaten, geen nieuwe interceptor nodig
};

// Set up interceptors
axiosClient.interceptors.request.use((config) => {
  // NOTE: This is a fallback for the case where the dossierNr is not set in the session, but in the header
  // NOTE: This does negate the effect of users not being able set theri own dossierNr!!!
  // TODO: SVEN: Remove this is we really don't want user to set their own dossierNr
  // TODO: SVEN: BUT the website will not work if setting cookies is prevented by the browser/user (very rare)

  if (dossierHeader) {
    config.headers["x-dossier"] = dossierHeader;
  }

  // Add language header to all requests
  if (i18n.language) {
    config.headers["x-lang"] = i18n.language;
  }

  return config;
});

axiosClient.interceptors.response.use(
  (response) => {
    // Controleer op success property voordat we response.data returnen
    if (response.data && response.data.success === false) {
      const error = new Error(response.data.message || "Request failed");
      error.i18nKey = response.data.i18nKey;
      error.response = response; // Behoud de originele response voor debugging
      throw error;
    }
    return response.data;
  },
  (error) => {
    handleAuthError(error);
    return Promise.reject(error);
  }
);

// Function to create a service-specific client
export const createServiceClient = (basePath) => {
  const client = axios.create({
    baseURL: getServerApiUrl() + basePath,
    withCredentials: true,
  });

  // Set up the same interceptors
  client.interceptors.request.use((config) => {
    if (dossierHeader) {
      config.headers["x-dossier"] = dossierHeader;
    }

    // Add language header to all requests
    if (i18n.language) {
      config.headers["x-lang"] = i18n.language;
    }

    return config;
  });

  client.interceptors.response.use(
    (response) => {
      // Check if this is a blob response (binary file download)
      if (response.data instanceof Blob) {
        // Return full response for blob data
        return response;
      }

      // Dezelfde controle voor service-specific clients
      if (response.data && response.data.success === false) {
        const error = new Error(response.data.message || "Request failed");
        error.i18nKey = response.data.i18nKey;
        error.response = response;
        throw error;
      }
      return response.data;
    },
    (error) => {
      handleAuthError(error);
      return Promise.reject(error);
    }
  );

  return client;
};

export default axiosClient;
